import { CONSOLE_PATHS } from "@sagot/constants";
import type { ReactElement } from "react";
import { RequirePermission } from "../pages/forbidden-page";
import { BillingPage } from "./workspace/billing/billing-page";
import { DashboardPage } from "./workspace/dashboard/dashboard-page";
import { GOOGLE_CALLBACK_PATH, GoogleCallbackPage } from "./workspace/settings/google-callback/google-callback-page";
import { SettingsPage } from "./workspace/settings/settings-page";

/** Screens owned by the "workspace" feature group, keyed by CONSOLE_PATHS value. */
export const workspaceScreens: Readonly<Record<string, ReactElement>> = {
  [CONSOLE_PATHS.dashboard]: (
    <RequirePermission permission="analytics.view">
      <DashboardPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.billing]: (
    <RequirePermission permission="billing.view">
      <BillingPage />
    </RequirePermission>
  ),
  // Settings gates per panel: everyone reaches their own Profile / Notifications panels.
  [CONSOLE_PATHS.settings]: <SettingsPage />,
  /** Google OAuth redirect: one fixed URL, so it is mounted outside `/w/:ws` (see app/routes.tsx). */
  [GOOGLE_CALLBACK_PATH]: <GoogleCallbackPage />,
};
